@import '../../styles/form.css';
@import '../../styles/buttons.css';
@import '../../styles/skeleton.css';

:host {
  padding: 20px 20px 0;
  display: block;
}

.tambr-password-form-item {
  position: relative;
  width: 50%;
  padding-right: 10px;
}

.tambr-password-form-item .edit-pass-btn {
  position: absolute;
  right: 5%;
  top: 50%;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: block;
}

.checkbox-wrapper {
  margin-top: 10px
}

.checkbox-wrapper input {
  vertical-align: middle;
  margin-right: 0.3rem;    
}

.checkbox-wrapper input:focus+label {
  font-size: inherit;
  transition: none;
}

.tambr-action-buttons { padding-top: 50px; }

.skeleton-card .card-actions {
  margin-top: 2rem;
}

.skeleton-button {
  width: 100px;
  margin: 0 auto; 
}